var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { getHeaders } from "../utils/apiUtils";
import { API_PATHS, legalDepositsEnforcementsIdCommunications, legalDepositsDepositRecordsByTitle, legalDepositsDepositRecordsIdReceive, legalDepositsDepositRecordsIdExclude, legalDepositsDepositRecordsIdReinstate, legalDepositsDepositRecordsIdReportDamaged, legalDepositsDepositRecordsIdDamagedClaim, legalDepositsDepositRecordsIdDamagedClaimPreview, legalDepositsDepositRecordsIdTimeline, legalDepositsTitlesIdExtraCopy, legalDepositsTitlesIdExtraCopyReceive, legalDepositsTitlesIdRequestCopy, legalDepositsTitlesIdRequestCopyPreview, legalDepositsTitlesIdExclude, legalDepositsTitlesIdReinstate, legalDepositsTitlesReinstateByTitles, legalDepositsDepositRecordsIdStatus, legalDepositsDepositRecordsIdReminderStatus, } from "../types/apiPaths";
export var fetchDepositRecordsByTitle = function (kyInstance, titleId) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                return [4 /*yield*/, kyInstance.get(legalDepositsDepositRecordsByTitle(titleId), { headers: getHeaders() })];
            case 1:
                response = _a.sent();
                if (!response.ok) {
                    throw new Error("Fetch deposit records error: ".concat(response.statusText));
                }
                return [4 /*yield*/, response.json()];
            case 2: return [2 /*return*/, _a.sent()];
            case 3:
                error_1 = _a.sent();
                console.error("Error fetching deposit records by title:", error_1);
                throw error_1;
            case 4: return [2 /*return*/];
        }
    });
}); };
export var fetchDepositRecords = function (kyInstance_1) {
    var args_1 = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args_1[_i - 1] = arguments[_i];
    }
    return __awaiter(void 0, __spreadArray([kyInstance_1], args_1, true), void 0, function (kyInstance, params) {
        var searchParams, response, error_2;
        if (params === void 0) { params = {}; }
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    searchParams = new URLSearchParams();
                    if (params.status)
                        searchParams.append("status", params.status);
                    if (params.titleId)
                        searchParams.append("titleId", params.titleId);
                    if (params.libraryId)
                        searchParams.append("libraryId", params.libraryId);
                    return [4 /*yield*/, kyInstance.get(API_PATHS.LEGAL_DEPOSITS_DEPOSIT_RECORDS, { searchParams: searchParams, headers: getHeaders() })];
                case 1:
                    response = _a.sent();
                    if (!response.ok) {
                        throw new Error("Fetch deposit records error: ".concat(response.statusText));
                    }
                    return [4 /*yield*/, response.json()];
                case 2: return [2 /*return*/, _a.sent()];
                case 3:
                    error_2 = _a.sent();
                    console.error("Error fetching deposit records:", error_2);
                    throw error_2;
                case 4: return [2 /*return*/];
            }
        });
    });
};
export var fetchEnforcements = function (kyInstance, depositRecordId) { return __awaiter(void 0, void 0, void 0, function () {
    var searchParams, response, error_3;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                searchParams = new URLSearchParams();
                searchParams.append("depositRecordId", depositRecordId);
                return [4 /*yield*/, kyInstance.get(API_PATHS.LEGAL_DEPOSITS_ENFORCEMENTS, { searchParams: searchParams, headers: getHeaders() })];
            case 1:
                response = _a.sent();
                if (!response.ok) {
                    throw new Error("Fetch enforcements error: ".concat(response.statusText));
                }
                return [4 /*yield*/, response.json()];
            case 2: return [2 /*return*/, _a.sent()];
            case 3:
                error_3 = _a.sent();
                console.error("Error fetching enforcements:", error_3);
                throw error_3;
            case 4: return [2 /*return*/];
        }
    });
}); };
export var fetchCommunications = function (kyInstance, enforcementId) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_4;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                return [4 /*yield*/, kyInstance.get(legalDepositsEnforcementsIdCommunications(enforcementId), { headers: getHeaders() })];
            case 1:
                response = _a.sent();
                if (!response.ok) {
                    throw new Error("Fetch communications error: ".concat(response.statusText));
                }
                return [4 /*yield*/, response.json()];
            case 2: return [2 /*return*/, _a.sent()];
            case 3:
                error_4 = _a.sent();
                console.error("Error fetching communications:", error_4);
                throw error_4;
            case 4: return [2 /*return*/];
        }
    });
}); };
export var fetchTimeline = function (kyInstance, depositRecordId) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_5;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                return [4 /*yield*/, kyInstance.get(legalDepositsDepositRecordsIdTimeline(depositRecordId), { headers: getHeaders() })];
            case 1:
                response = _a.sent();
                if (!response.ok) {
                    throw new Error("Fetch timeline error: ".concat(response.statusText));
                }
                return [4 /*yield*/, response.json()];
            case 2: return [2 /*return*/, _a.sent()];
            case 3:
                error_5 = _a.sent();
                console.error("Error fetching timeline:", error_5);
                throw error_5;
            case 4: return [2 /*return*/];
        }
    });
}); };
export var fetchReminderStatus = function (kyInstance, depositRecordId) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_6;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                return [4 /*yield*/, kyInstance.get(legalDepositsDepositRecordsIdReminderStatus(depositRecordId), { headers: getHeaders() })];
            case 1:
                response = _a.sent();
                if (!response.ok) {
                    throw new Error("Fetch reminder status error: ".concat(response.statusText));
                }
                return [4 /*yield*/, response.json()];
            case 2: return [2 /*return*/, _a.sent()];
            case 3:
                error_6 = _a.sent();
                console.error("Error fetching reminder status:", error_6);
                throw error_6;
            case 4: return [2 /*return*/];
        }
    });
}); };
export var receiveDeposit = function (kyInstance, id) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_7;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                return [4 /*yield*/, kyInstance.patch(legalDepositsDepositRecordsIdReceive(id), { headers: getHeaders() })];
            case 1:
                response = _a.sent();
                if (!response.ok) {
                    throw new Error("Receive deposit error: ".concat(response.statusText));
                }
                return [4 /*yield*/, response.json()];
            case 2: return [2 /*return*/, _a.sent()];
            case 3:
                error_7 = _a.sent();
                console.error("Error receiving deposit:", error_7);
                throw error_7;
            case 4: return [2 /*return*/];
        }
    });
}); };
export var fetchAgencyTitleDetail = function (kyInstance, productNumber) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_8;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, kyInstance.get(API_PATHS.LEGAL_DEPOSITS_DEPOSIT_RECORDS_AGENCY_TITLE_DETAIL, {
                        searchParams: { productNumber: productNumber },
                        headers: getHeaders(),
                    })];
            case 1:
                response = _a.sent();
                if (!response.ok) {
                    throw new Error("Fetch agency title detail error: ".concat(response.statusText));
                }
                return [2 /*return*/, response.json()];
            case 2:
                error_8 = _a.sent();
                console.error("Error fetching agency title detail:", error_8);
                throw error_8;
            case 3: return [2 /*return*/];
        }
    });
}); };
export var receiveByIsbn = function (kyInstance_1, isbn_1) {
    var args_1 = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        args_1[_i - 2] = arguments[_i];
    }
    return __awaiter(void 0, __spreadArray([kyInstance_1, isbn_1], args_1, true), void 0, function (kyInstance, isbn, confirm, titleId) {
        var response;
        if (confirm === void 0) { confirm = false; }
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, kyInstance.post(API_PATHS.LEGAL_DEPOSITS_DEPOSIT_RECORDS_RECEIVE_BY_ISBN, { json: { isbn: isbn, confirm: confirm, titleId: titleId }, headers: getHeaders() })];
                case 1:
                    response = _a.sent();
                    if (!response.ok)
                        throw new Error("Receive by ISBN error: ".concat(response.statusText));
                    return [2 /*return*/, response.json()];
            }
        });
    });
};
export var confirmAgencyTitle = function (kyInstance, isbn, agencyProductId) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, kyInstance.post(API_PATHS.LEGAL_DEPOSITS_DEPOSIT_RECORDS_CONFIRM_AGENCY_TITLE, { json: { isbn: isbn, agencyProductId: agencyProductId }, headers: getHeaders() })];
            case 1:
                response = _a.sent();
                if (!response.ok)
                    throw new Error("Confirm agency title error: ".concat(response.statusText));
                return [2 /*return*/, response.json()];
        }
    });
}); };
export var excludeDeposit = function (kyInstance, id, request) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_9;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                return [4 /*yield*/, kyInstance.patch(legalDepositsDepositRecordsIdExclude(id), { json: request, headers: getHeaders() })];
            case 1:
                response = _a.sent();
                if (!response.ok) {
                    throw new Error("Exclude deposit error: ".concat(response.statusText));
                }
                return [4 /*yield*/, response.json()];
            case 2: return [2 /*return*/, _a.sent()];
            case 3:
                error_9 = _a.sent();
                console.error("Error excluding deposit:", error_9);
                throw error_9;
            case 4: return [2 /*return*/];
        }
    });
}); };
export var reinstateDeposit = function (kyInstance, id) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_10;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                return [4 /*yield*/, kyInstance.patch(legalDepositsDepositRecordsIdReinstate(id), { headers: getHeaders() })];
            case 1:
                response = _a.sent();
                if (!response.ok) {
                    throw new Error("Reinstate deposit error: ".concat(response.statusText));
                }
                return [4 /*yield*/, response.json()];
            case 2: return [2 /*return*/, _a.sent()];
            case 3:
                error_10 = _a.sent();
                console.error("Error reinstating deposit:", error_10);
                throw error_10;
            case 4: return [2 /*return*/];
        }
    });
}); };
export var reportDamaged = function (kyInstance, id) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, kyInstance.patch(legalDepositsDepositRecordsIdReportDamaged(id), { headers: getHeaders() })];
            case 1:
                response = _a.sent();
                if (!response.ok)
                    throw new Error("Report damaged error: ".concat(response.statusText));
                return [2 /*return*/, response.json()];
        }
    });
}); };
export var changeDepositRecordStatus = function (kyInstance, id, request) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, kyInstance.patch(legalDepositsDepositRecordsIdStatus(id), { json: request, headers: getHeaders() })];
            case 1:
                response = _a.sent();
                if (!response.ok)
                    throw new Error("Change status error: ".concat(response.statusText));
                return [2 /*return*/, response.json()];
        }
    });
}); };
export var previewDamagedClaim = function (kyInstance, depositRecordId) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, kyInstance.post(legalDepositsDepositRecordsIdDamagedClaimPreview(depositRecordId), { headers: getHeaders() })];
            case 1:
                response = _a.sent();
                if (!response.ok)
                    throw new Error("Preview damaged claim error: ".concat(response.statusText));
                return [2 /*return*/, response.json()];
        }
    });
}); };
export var sendDamagedClaim = function (kyInstance, depositRecordId, request) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, kyInstance.post(legalDepositsDepositRecordsIdDamagedClaim(depositRecordId), { json: request, headers: getHeaders() })];
            case 1:
                response = _a.sent();
                if (!response.ok)
                    throw new Error("Send damaged claim error: ".concat(response.statusText));
                return [2 /*return*/];
        }
    });
}); };
export var addExtraCopy = function (kyInstance, titleId, request) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_11;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                return [4 /*yield*/, kyInstance.post(legalDepositsTitlesIdExtraCopy(titleId), { json: request, headers: getHeaders() })];
            case 1:
                response = _a.sent();
                if (!response.ok) {
                    throw new Error("Add extra copy error: ".concat(response.statusText));
                }
                return [4 /*yield*/, response.json()];
            case 2: return [2 /*return*/, _a.sent()];
            case 3:
                error_11 = _a.sent();
                console.error("Error adding extra copy:", error_11);
                throw error_11;
            case 4: return [2 /*return*/];
        }
    });
}); };
export var receiveExtraCopy = function (kyInstance, titleId, request) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, kyInstance.post(legalDepositsTitlesIdExtraCopyReceive(titleId), { json: request, headers: getHeaders() })];
            case 1:
                response = _a.sent();
                if (!response.ok)
                    throw new Error("Receive extra copy error: ".concat(response.statusText));
                return [2 /*return*/, response.json()];
        }
    });
}); };
export var requestCopy = function (kyInstance, titleId, request) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, kyInstance.post(legalDepositsTitlesIdRequestCopy(titleId), { json: request, headers: getHeaders() })];
            case 1:
                response = _a.sent();
                if (!response.ok)
                    throw new Error("Request copy error: ".concat(response.statusText));
                return [2 /*return*/, response.json()];
        }
    });
}); };
export var previewRequestCopy = function (kyInstance, titleId) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, kyInstance.post(legalDepositsTitlesIdRequestCopyPreview(titleId), { headers: getHeaders() })];
            case 1:
                response = _a.sent();
                if (!response.ok)
                    throw new Error("Preview request copy error: ".concat(response.statusText));
                return [2 /*return*/, response.json()];
        }
    });
}); };
export var excludeTitle = function (kyInstance, titleId, request) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_12;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                return [4 /*yield*/, kyInstance.patch(legalDepositsTitlesIdExclude(titleId), { json: request, headers: getHeaders() })];
            case 1:
                response = _a.sent();
                if (!response.ok) {
                    throw new Error("Exclude title error: ".concat(response.statusText));
                }
                return [4 /*yield*/, response.json()];
            case 2: return [2 /*return*/, _a.sent()];
            case 3:
                error_12 = _a.sent();
                console.error("Error excluding title:", error_12);
                throw error_12;
            case 4: return [2 /*return*/];
        }
    });
}); };
export var reinstateByTitles = function (kyInstance, selection) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_13;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                return [4 /*yield*/, kyInstance.patch(legalDepositsTitlesReinstateByTitles, { json: { selection: selection }, headers: getHeaders() })];
            case 1:
                response = _a.sent();
                if (!response.ok) {
                    throw new Error("Reinstate by titles error: ".concat(response.statusText));
                }
                return [4 /*yield*/, response.json()];
            case 2: return [2 /*return*/, _a.sent()];
            case 3:
                error_13 = _a.sent();
                console.error("Error reinstating by titles:", error_13);
                throw error_13;
            case 4: return [2 /*return*/];
        }
    });
}); };
export var reinstateTitle = function (kyInstance, titleId) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_14;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                return [4 /*yield*/, kyInstance.patch(legalDepositsTitlesIdReinstate(titleId), { headers: getHeaders() })];
            case 1:
                response = _a.sent();
                if (!response.ok) {
                    throw new Error("Reinstate title error: ".concat(response.statusText));
                }
                return [4 /*yield*/, response.json()];
            case 2: return [2 /*return*/, _a.sent()];
            case 3:
                error_14 = _a.sent();
                console.error("Error reinstating title:", error_14);
                throw error_14;
            case 4: return [2 /*return*/];
        }
    });
}); };
export var createUrgence = function (kyInstance, request, department) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_15;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                return [4 /*yield*/, kyInstance.post(API_PATHS.LEGAL_DEPOSITS_ENFORCEMENTS_URGENCE, { json: request, searchParams: { department: department }, headers: getHeaders() })];
            case 1:
                response = _a.sent();
                if (!response.ok) {
                    throw new Error("Create urgence error: ".concat(response.statusText));
                }
                return [4 /*yield*/, response.json()];
            case 2: return [2 /*return*/, _a.sent()];
            case 3:
                error_15 = _a.sent();
                console.error("Error creating urgence:", error_15);
                throw error_15;
            case 4: return [2 /*return*/];
        }
    });
}); };
export var previewUrgence = function (kyInstance, depositRecordIds, type, department) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_16;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                return [4 /*yield*/, kyInstance.post(API_PATHS.LEGAL_DEPOSITS_ENFORCEMENTS_URGENCE_PREVIEW, {
                        json: depositRecordIds,
                        searchParams: { type: type, department: department },
                        headers: getHeaders(),
                    })];
            case 1:
                response = _a.sent();
                if (!response.ok) {
                    throw new Error("Preview urgence error: ".concat(response.statusText));
                }
                return [4 /*yield*/, response.json()];
            case 2: return [2 /*return*/, _a.sent()];
            case 3:
                error_16 = _a.sent();
                console.error("Error previewing urgence:", error_16);
                throw error_16;
            case 4: return [2 /*return*/];
        }
    });
}); };
export var createDamagedClaim = function (kyInstance, request, department) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, kyInstance.post(API_PATHS.LEGAL_DEPOSITS_ENFORCEMENTS_DAMAGED_CLAIM, { json: request, searchParams: { department: department }, headers: getHeaders() })];
            case 1:
                response = _a.sent();
                if (!response.ok)
                    throw new Error("Create damaged claim error: ".concat(response.statusText));
                return [2 /*return*/, response.json()];
        }
    });
}); };
export var previewDamagedClaimByRecords = function (kyInstance, depositRecordIds, department) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, kyInstance.post(API_PATHS.LEGAL_DEPOSITS_ENFORCEMENTS_DAMAGED_CLAIM_PREVIEW, {
                    json: depositRecordIds,
                    searchParams: { department: department },
                    headers: getHeaders(),
                })];
            case 1:
                response = _a.sent();
                if (!response.ok)
                    throw new Error("Preview damaged claim error: ".concat(response.statusText));
                return [2 /*return*/, response.json()];
        }
    });
}); };
export var createUrgenceByTitles = function (kyInstance, request) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, kyInstance.post(API_PATHS.LEGAL_DEPOSITS_ENFORCEMENTS_URGENCE_BY_TITLES, { json: request, headers: getHeaders() })];
            case 1:
                response = _a.sent();
                if (!response.ok)
                    throw new Error("Create urgence error: ".concat(response.statusText));
                return [2 /*return*/, response.json()];
        }
    });
}); };
export var previewUrgenceByTitles = function (kyInstance_1, selection_1) {
    var args_1 = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        args_1[_i - 2] = arguments[_i];
    }
    return __awaiter(void 0, __spreadArray([kyInstance_1, selection_1], args_1, true), void 0, function (kyInstance, selection, type) {
        var response;
        if (type === void 0) { type = "URGENCE"; }
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, kyInstance.post("".concat(API_PATHS.LEGAL_DEPOSITS_ENFORCEMENTS_URGENCE_BY_TITLES_PREVIEW, "?type=").concat(type), { json: selection, headers: getHeaders() })];
                case 1:
                    response = _a.sent();
                    if (!response.ok)
                        throw new Error("Preview urgence error: ".concat(response.statusText));
                    return [2 /*return*/, response.json()];
            }
        });
    });
};
export var createUrgenceByPublisher = function (kyInstance, request) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, kyInstance.post(API_PATHS.LEGAL_DEPOSITS_ENFORCEMENTS_URGENCE_BY_PUBLISHER, { json: request, headers: getHeaders() })];
            case 1:
                response = _a.sent();
                if (!response.ok)
                    throw new Error("Create urgence error: ".concat(response.statusText));
                return [2 /*return*/, response.json()];
        }
    });
}); };
export var previewUrgenceByPublisher = function (kyInstance, publisherId) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, kyInstance.post(API_PATHS.LEGAL_DEPOSITS_ENFORCEMENTS_URGENCE_BY_PUBLISHER_PREVIEW, { json: { publisherId: publisherId }, headers: getHeaders() })];
            case 1:
                response = _a.sent();
                if (!response.ok)
                    throw new Error("Preview urgence error: ".concat(response.statusText));
                return [2 /*return*/, response.json()];
        }
    });
}); };
export var previewDamagedClaimByTitles = function (kyInstance, selection) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, kyInstance.post(API_PATHS.LEGAL_DEPOSITS_TITLES_DAMAGED_CLAIM_BY_TITLES_PREVIEW, { json: selection, headers: getHeaders() })];
            case 1:
                response = _a.sent();
                if (!response.ok)
                    throw new Error("Preview damaged claim error: ".concat(response.statusText));
                return [2 /*return*/, response.json()];
        }
    });
}); };
export var sendDamagedClaimByTitles = function (kyInstance, request) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, kyInstance.post(API_PATHS.LEGAL_DEPOSITS_TITLES_DAMAGED_CLAIM_BY_TITLES, { json: request, headers: getHeaders() })];
            case 1:
                response = _a.sent();
                if (!response.ok)
                    throw new Error("Send bulk damaged claim error: ".concat(response.statusText));
                return [2 /*return*/, response.json()];
        }
    });
}); };
export var previewRequestCopyByTitles = function (kyInstance, selection) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, kyInstance.post(API_PATHS.LEGAL_DEPOSITS_TITLES_REQUEST_COPY_BY_TITLES_PREVIEW, { json: selection, headers: getHeaders() })];
            case 1:
                response = _a.sent();
                if (!response.ok)
                    throw new Error("Preview request copy error: ".concat(response.statusText));
                return [2 /*return*/, response.json()];
        }
    });
}); };
export var requestCopyByTitles = function (kyInstance, request) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, kyInstance.post(API_PATHS.LEGAL_DEPOSITS_TITLES_REQUEST_COPY_BY_TITLES, { json: request, headers: getHeaders() })];
            case 1:
                response = _a.sent();
                if (!response.ok)
                    throw new Error("Request copy by titles error: ".concat(response.statusText));
                return [2 /*return*/, response.json()];
        }
    });
}); };
export var previewExcludeByTitles = function (kyInstance, selection) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, kyInstance.post(API_PATHS.LEGAL_DEPOSITS_TITLES_EXCLUDE_BY_TITLES_PREVIEW, { json: selection, headers: getHeaders() })];
            case 1:
                response = _a.sent();
                if (!response.ok)
                    throw new Error("Preview exclude error: ".concat(response.statusText));
                return [2 /*return*/, response.json()];
        }
    });
}); };
export var excludeByTitles = function (kyInstance, request) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, kyInstance.patch(API_PATHS.LEGAL_DEPOSITS_TITLES_EXCLUDE_BY_TITLES, { json: request, headers: getHeaders() })];
            case 1:
                response = _a.sent();
                if (!response.ok)
                    throw new Error("Exclude by titles error: ".concat(response.statusText));
                return [2 /*return*/, response.json()];
        }
    });
}); };
export var previewPreLitigation = function (kyInstance, publisherId) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, kyInstance.post(API_PATHS.LEGAL_DEPOSITS_ENFORCEMENTS_PRE_LITIGATION_PREVIEW, { json: { publisherId: publisherId }, headers: getHeaders() })];
            case 1:
                response = _a.sent();
                if (!response.ok)
                    throw new Error("Preview pre-litigation error: ".concat(response.statusText));
                return [2 /*return*/, response.json()];
        }
    });
}); };
export var createPreLitigation = function (kyInstance, request) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, kyInstance.post(API_PATHS.LEGAL_DEPOSITS_ENFORCEMENTS_PRE_LITIGATION, { json: request, headers: getHeaders() })];
            case 1:
                response = _a.sent();
                if (!response.ok)
                    throw new Error("Create pre-litigation error: ".concat(response.statusText));
                return [2 /*return*/, response.json()];
        }
    });
}); };
export var downloadPreLitigationReport = function (kyInstance, depositRecordIds) { return __awaiter(void 0, void 0, void 0, function () {
    var response, blob, url, link;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, kyInstance.post(API_PATHS.LEGAL_DEPOSITS_ENFORCEMENTS_PRE_LITIGATION_REPORT, { json: { depositRecordIds: depositRecordIds }, headers: getHeaders() })];
            case 1:
                response = _a.sent();
                if (!response.ok)
                    throw new Error("Pre-litigation report error: ".concat(response.statusText));
                return [4 /*yield*/, response.blob()];
            case 2:
                blob = _a.sent();
                url = URL.createObjectURL(blob);
                link = document.createElement("a");
                link.href = url;
                link.download = "predzalobni-vyzva-soupis.pdf";
                link.click();
                URL.revokeObjectURL(url);
                return [2 /*return*/];
        }
    });
}); };
